import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from "primeng/api";
import { MenuService } from "../../services/menu.service";
import { TranslocoPipe, TranslocoService } from "@ngneat/transloco";
import { first } from "rxjs/operators";
import { LoggedUser } from "../../common/logged-user.service";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [TranslocoPipe],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {

  @Input() showMenu: boolean;

  items: MenuItem[];

  constructor(private menuService: MenuService,
              private loggedUser: LoggedUser,
              private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.loadItems();
  }

  private loadItems(): void {
    this.loggedUser.userObservable.subscribe( () => this.refreshItems());
    this.translocoService.langChanges$.subscribe(() => this.refreshItems());
  }

  private refreshItems() {
    let promises = [];
    let items = [];
    this.menuService.getItems().forEach(item => {
      promises.push(this.translocoService.selectTranslate(item.label).pipe(first()).toPromise());
      items.push({label: item.label, icon: item.icon, routerLink: item.routerLink});
    });
    Promise.all(promises).then(values => {
      for(let i = 0; i < values.length; i++) {
        items[i].label = values[i];
      }
      this.items = items;
    })
  }
}
